import {ApolloClient, gql, NormalizedCacheObject, useQuery} from '@apollo/client';
import {Query} from '../types/generated/graphql';

/**
 * Channel-feedback data-quality buckets (GOOD / BAD / TBD) combining
 * per-video parent votes (rolled up to the channel) + explicit
 * FOLLOW/BLOCK channel actions. `profileId` null = all kids combined.
 */
export const useGetChannelFeedbackQuality = (
  client: ApolloClient<NormalizedCacheObject>,
  profileId: string | null,
) => {
  type T = Pick<Query, 'getChannelFeedbackQuality'>;
  return useQuery<T>(QUERY, {
    client,
    variables: {profileId: profileId || null},
    fetchPolicy: 'cache-and-network',
  });
};

const ROW = `
  channelId
  channelName
  avatarUrl
  yesVotes
  noVotes
  skipVotes
  followed
  blocked
  netScore
`;

const QUERY = gql`
  query getChannelFeedbackQuality($profileId: String) {
    getChannelFeedbackQuality(profileId: $profileId) {
      goodCount
      badCount
      tbdCount
      good { ${ROW} }
      bad { ${ROW} }
      tbd { ${ROW} }
    }
  }
`;
